import Vue from "vue";
import Router from "vue-router";
import getSettingtext from "@/assets/settings.json";
import jsonData from "@/assets/js/functions/getJson.js";

Vue.use(Router);
const getJson = jsonData.getJson()
const title = getJson.title; // ドリルタイトル
const title_html = getJson.title_html; // タイトルhtml
const title_id = getJson.title_id; // タイトルID

const ls_key = title_id + "_data"; // タイトルキー

export default new Router({
  routes: [
    {
      path: "/",
      name: "home",
      component: () => import("./views/home.vue"),
      props: {
        title: title,
        title_id: title_id,
        title_html: title_html,
        ls_key: ls_key,
        jsonObj: getJson,
        SettingObj: getSettingtext
      }
    },
    {
      path: "/selection",
      name: "selection",
      component: () => import("./views/selection.vue"),
      props: {
        title: title,
        title_html: title_html,
        title_id: title_id,
        ls_key: ls_key,
        jsonObj: getJson,
        SettingObj: getSettingtext
      }
    },
    {
      path: "/result",
      name: "result",
      component: () => import("./views/result.vue"),
      props: {
        title: title,
        title_html: title_html,
        title_id: title_id,
        ls_key: ls_key,
        jsonObj: getJson,
        SettingObj: getSettingtext
      }
    },
    {
      path: "/:exam",
      name: "exam",
      component: () => import("./views/exam.vue"),
      props: {
        title: title,
        title_html: title_html,
        title_id: title_id,
        ls_key: ls_key,
        jsonObj: getJson,
        SettingObj: getSettingtext
      }
    }
  ]
});
